"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../../style/colors");
var _fonts = require("../../style/fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledNavBarProducts = /*#__PURE__*/_styledComponents.default.nav.withConfig({
  displayName: "NavBarProducts__StyledNavBarProducts",
  componentId: "bufferapp-ui__sc-4g6kwy-0"
})(["display:flex;position:relative;z-index:2;"]);
const ProductLink = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "NavBarProducts__ProductLink",
  componentId: "bufferapp-ui__sc-4g6kwy-1"
})(["height:100%;display:flex;color:#fff;padding:0 24px;font-size:16px;text-decoration:none;align-items:center;color:", ";background-color:", ";&:hover{color:", ";background-color:", ";}& svg{filter:grayscale(1) contrast(0.5);filter:", ";}"], props => props.active ? _colors.blueDarker : _colors.grayDark, props => props.active ? _colors.grayLighter : 'transparent', props => props.active ? _colors.blueDarker : _colors.grayDark, _colors.grayLighter, props => props.active ? 'grayscale(0) contrast(1)' : 'grayscale(1) contrast(.5)');
const ProductText = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "NavBarProducts__ProductText",
  componentId: "bufferapp-ui__sc-4g6kwy-2"
})(["font-family:", ";font-weight:", ";margin-left:8px;text-transform:capitalize;"], _fonts.fontFamily, _fonts.fontWeightMedium);
const NewLabel = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "NavBarProducts__NewLabel",
  componentId: "bufferapp-ui__sc-4g6kwy-3"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";background:", ";border-radius:12px;padding:2px 8px;margin-left:8px;margin-top:2px;"], _colors.white, _fonts.fontFamily, _fonts.fontWeightMedium, _fonts.fontSizeSmall, _colors.green);
const PublishLogo = () => ( /*#__PURE__*/_react.default.createElement("svg", {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.38324 6.40009L10.3798 10.407V16.0001L0.771271 6.40009H6.38324Z",
  fill: "#132062"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9979 13.5234V0H3.47618L16.9979 13.5234Z",
  fill: "#6B81FF"
})));
const AnalyzeLogo = () => ( /*#__PURE__*/_react.default.createElement("svg", {
  width: "19",
  height: "20",
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.1336 2.8703C3.28309 2.8703 0.167206 6.03021 0.167206 9.93515C0.167206 13.8401 3.28309 17 7.1336 17C10.9841 17 14.1 13.8401 14.1 9.93515H7.1336V2.8703Z",
  fill: "#F3AFB9"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8.00839C16 4.10346 12.8841 0.943542 9.0336 0.943542V8.00839H16Z",
  fill: "#132062"
})));
const EngageLogo = () => ( /*#__PURE__*/_react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M16 9.03754H8.9274V16H16V9.03754Z",
  fill: "#132062"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H13.8055V6.94855H6.83673V13.911L0 13.925V0Z",
  fill: "#87C221"
})));
const getLogo = product => {
  switch (product) {
    case 'analyze':
      return /*#__PURE__*/_react.default.createElement(AnalyzeLogo, null);
    case 'publish':
      return /*#__PURE__*/_react.default.createElement(PublishLogo, null);
    case 'engage':
      return /*#__PURE__*/_react.default.createElement(EngageLogo, null);
    default:
      return null;
  }
};
const NavBarProducts = _ref => {
  let {
    products,
    activeProduct
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledNavBarProducts, null, products.map(_ref2 => {
    let {
      id,
      href,
      isNew
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(ProductLink, {
      active: activeProduct === id,
      href: href,
      key: id,
      id: `product-${id}`
    }, getLogo(id), /*#__PURE__*/_react.default.createElement(ProductText, null, id), isNew && ( /*#__PURE__*/_react.default.createElement(NewLabel, {
      "aria-label": "This is a new product! Give it a try!"
    }, "New!")));
  }));
};
NavBarProducts.propTypes = {
  products: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    isNew: _propTypes.default.bool,
    href: _propTypes.default.string
  })),
  activeProduct: _propTypes.default.oneOf(['publish', 'analyze', 'engage'])
};
NavBarProducts.defaultProps = {
  products: [],
  activeProduct: undefined
};
var _default = exports.default = NavBarProducts;